import {
  RenterAssessmentParams,
  RenterAssessmentItem,
  RenterAccessmentBadge,
} from '../../interfaces/renter-profile-assessment.interface';

export const petsAssessmentBadges: {
  hasPetsNotAllowed: RenterAccessmentBadge;
} = {
  hasPetsNotAllowed: { title: 'Has pets', badgeColor: 'red' },
};

export function getPetsAssessment(assessmentParams: RenterAssessmentParams): RenterAssessmentItem {
  const hasPets = assessmentParams.renter?.hasPets;
  const petPolicy = assessmentParams.property?.petPolicy;
  const uiRepresentation = hasPets === undefined ? 'N/A' : hasPets ? 'Yes' : 'No';

  let badge: RenterAccessmentBadge | null = null;

  if (hasPets === true && petPolicy && petPolicy.allowsPets === false) {
    badge = petsAssessmentBadges.hasPetsNotAllowed;
  }

  return {
    uiRepresentation,
    badge,
  };
}
